import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { bloodPressure7day, bloodPressure30day } from '../mockData/blood-pressure-data';

const BloodPressureApi = [
  rest.get(`${API_ROOT}blood-pressure`, (req, res, ctx) => {
    const period = req.url.searchParams.get('period');
    if (period === '7') {
      return res(ctx.json(bloodPressure7day));
    }
    return res(ctx.json(bloodPressure30day));
  }),
];

export default BloodPressureApi;
